// Tolerates DOM nodes moved by browser translation/extensions so React doesn't crash.
export function installDomGuard() {
  if (typeof Node === "undefined" || Node.prototype.__aphGuard) return;
  Node.prototype.__aphGuard = true;
  const remove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) return child.parentNode ? child.parentNode.removeChild(child) : child;
    return remove.call(this, child);
  };
  const insert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (node, ref) {
    if (ref && ref.parentNode !== this) return insert.call(this, node, null);
    return insert.call(this, node, ref);
  };
}
